import simg1 from '../images/services/icon-1.png'
import simg2 from '../images/services/icon-2.png'
import simg3 from '../images/services/icon-3.png'
import simg4 from '../images/services/icon-4.png'

import sSimg1 from '../images/service-single/1.jpg'
import sSimg2 from '../images/service-single/1.jpg'
import sSimg3 from '../images/service-single/1.jpg'
import sSimg4 from '../images/service-single/1.jpg'

import icon1 from '../images/services/icon-1.png'
import icon2 from '../images/services/icon-2.png'
import icon3 from '../images/services/icon-3.png'
import icon4 from '../images/services/icon-4.png'

import { Link } from 'react-router-dom';


const Services = [
   {
      Id: '01',
      sImg: simg1,
      sSImg: sSimg1,
      icon: icon1,
      title: 'Home Interiors',
      link: 'homeinteriors',
      description: 'Beautiful Homes Start with Thoughtful Design',
   },
   {
      Id: '02',
      sImg: simg2,
      sSImg: sSimg2,
      icon: icon2,
      title: 'Commercial Interiors',
      link: 'commercialinteriors',
      description: 'Make a Statement with Smart Commercial Spaces',
   },

   {
      Id: '03',
      sImg: simg3,
      sSImg: sSimg3,
      icon: icon3,
      title: 'Office Interiors',
      link: 'officeinteriors',
      description: 'Smart Office Designs for Modern Workplaces',
   },
   {
      Id: '04',
      sImg: simg4,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Electrical & Lighting Solutions',
      link: 'electricallighting',
      description: 'Safe, Efficient & Elegant Electrical Installations',
   },
   {
      Id: '05',
      sImg: simg2,
      sSImg: sSimg2,
      icon: icon2,
      title: 'Painting Works',
      link: 'paintingwork',
      description: 'From Color Consultation to Perfect Finish',
   },
    {
      Id: '06',
      sImg: simg2,
      sSImg: sSimg2,
      icon: icon2,
      title: 'Plumbing Works',
      link:  'plumbingwork',
      description: 'Professional Plumbing That Flows Right',
   },
    {
      Id: '07',
      sImg: simg2,
      sSImg: sSimg2,
      icon: icon2,
      title: 'Renovation Works',
      link: 'renovationwork',
      description: 'Give Your Old Space a Fresh New Life',
   },
    {
      Id: '08',
      sImg: simg2,
      sSImg: sSimg2,
      icon: icon2,
      title: 'Carpentry Works',
      link: 'Carpentryworks',
      description: 'Custom Carpentry Tailored to Your Space',
   },

]

export default Services;